import { useEffect, useRef, useState } from "react";

/**
 * Detecta cuándo un elemento entra en el viewport (una sola vez).
 * Útil para animaciones de aparición al hacer scroll (scroll-reveal).
 */
export function useInView<T extends HTMLElement = HTMLDivElement>(
    options?: IntersectionObserverInit,
) {
    const ref = useRef<T>(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el || typeof IntersectionObserver === "undefined") {
            setInView(true);
            return;
        }
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.2, ...options },
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return { ref, inView };
}
